export const UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY = 'UNIT_TRUST';
export const EQUITY_INVESTMENT_ACCOUNT_CATEGORY = 'EQUITIES';
export const STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY = 'STRUCTURED_PRODUCTS';
export const BONDS_ACCOUNT_CATEGORY = 'BONDS';
